import { useState, useEffect, useRef } from 'react';
import { useWeb3 } from '../context/Web3Context';
import { useContracts } from './useContract';

// Resolves the connected wallet's role against the contract.
//  isOwner -> full admin panel (incl. router + ownership)
//  isAdmin -> basic admin panel (router HIDDEN). Owner is also admin.
export function useRole() {
  const { account } = useWeb3();
  const { evittaRead } = useContracts();

  const [role, setRole] = useState({
    loaded: false,
    isOwner: false,
    isAdmin: false,
    owner: null,
    admin: null,
  });

  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (!evittaRead || !account) {
      setRole({ loaded: true, isOwner: false, isAdmin: false, owner: null, admin: null });
      return undefined;
    }
    let cancelled = false;
    (async () => {
      try {
        const [owner, admin] = await Promise.all([
          evittaRead.owner(),
          evittaRead.admin(),
        ]);
        if (cancelled || !mounted.current) return;
        const a = account.toLowerCase();
        const isOwner = !!owner && owner.toLowerCase() === a;
        const isAdminWallet = !!admin && admin.toLowerCase() === a;
        setRole({
          loaded: true,
          isOwner,
          isAdmin: isOwner || isAdminWallet, // owner inherits admin rights
          owner,
          admin,
        });
      } catch {
        if (!cancelled && mounted.current) {
          setRole({ loaded: true, isOwner: false, isAdmin: false, owner: null, admin: null });
        }
      }
    })();
    return () => { cancelled = true; };
  }, [evittaRead, account]);

  return role;
}
